const observer = new MutationObserver(mutations => {
  for (const { target, attributeName } of mutations) {
    if (attributeName !== 'aria-hidden') continue;
    const hidden = target.getAttribute('aria-hidden') === 'true';
    target.querySelectorAll('a, button, input').forEach(el => {
      if (hidden) {
        el.dataset.prevTabindex = el.getAttribute('tabindex') ?? '';
        el.setAttribute('tabindex', '-1');
        el.setAttribute('aria-hidden', 'true');
      } else {
        const prev = el.dataset.prevTabindex;
        prev ? el.setAttribute('tabindex', prev) : el.removeAttribute('tabindex');
        el.removeAttribute('aria-hidden');
        delete el.dataset.prevTabindex;
      }
    });
  }
});

observer.observe(document.body, { subtree: true, attributeFilter: ['aria-hidden'] });

const fixAlt = (el) => {
    if (!el.hasAttribute('alt')) el.setAttribute('alt', '');
};

document.querySelectorAll('img').forEach(fixAlt);

new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (node.nodeType !== Node.ELEMENT_NODE) return;
            if (node.tagName === 'IMG') fixAlt(node);
            node.querySelectorAll('img').forEach(fixAlt);
        });
    });
}).observe(document.body, { childList: true, subtree: true });
